import "./index.css";


function Loading(){

	return(

		<section id="load">
			<div className="house">
				<div className="box1"> </div>
				<div className="box2"> </div>
				<div className="box3"> </div>
			</div>
			
		</section>

		)
}

export default Loading;